module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "w25"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QIsa"), _c('sup', {
    staticClass: "superscript"
  }, [_vm._v("a")])])]), _c('td', {
    staticClass: "w75"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isaiah"), _c('sup', {
    staticClass: "superscript"
  }, [_vm._v("a")]), _vm._v(" (Dead Sea Scrolls – ‘Great Isaiah Scroll’)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("1QIsa"), _c('sup', {
    staticClass: "superscript"
  }, [_vm._v("b")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Isaiah"), _c('sup', {
    staticClass: "superscript"
  }, [_vm._v("b")]), _vm._v(" (Dead Sea Scrolls)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4Q161")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Pesher Isaiah (Dead Sea Scrolls)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("4Q163")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("papPesher Isaiah (Dead Sea Scrolls)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AB")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Anchor Bible Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ABD")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Anchor Bible Dictionary")]), _vm._v(", ed. D. N. Freedman. 6 vols. New York, 1992.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BBRSup")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bulletin for Biblical Research Supplements")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BETL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bibliotheca ephemeridum theologicarum lovaniensium")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BIntS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical Interpretation Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BSac")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bibliotheca sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZAW")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZNW")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CBQ")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Catholic Biblical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CBQMS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Catholic Biblical Quarterly Monograph Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("COS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Context of Scripture")]), _vm._v(", ed. W. W. Hallo and K. L. Younger. 3 vols. Leiden, 1997–2003.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESV")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("English Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FAT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FOTL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forms of the Old Testament Literature")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HCOT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Historical Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HUCA")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hebrew Union College Annual")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ICC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JQR")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Jewish Quarterly Review")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSSM")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal of Semitic Studies Monograph")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LHBOTS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Library of the Hebrew Bible/Old Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LXX")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Septuagint")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masoretic Text")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NAC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New American Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICOT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIGTC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Greek Testament Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NIV")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NKJV")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New King James Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NRSV")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Revised Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NSBT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTSup")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Novum Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OBT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Overtures in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTM")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Oxford Theological Monographs")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLAIL")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Ancient Israel and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJOT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scandinavian Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TJ")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Trinity Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VTSup")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WTJ")])])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Westminster Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WUNT")])]), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38673585","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbrevation.vue
// module id = 75
// module chunks = 0